<template>
  <a class="arrow-right" :class="isContactPanelActive ? 'fadeout-desktop': 'fadein-desktop'">
    <img src="../assets/img/arrow-right.svg" alt />
  </a>
</template>

<script>
export default {
  name: "ArrowRight",
  props: {
    isContactPanelActive: Boolean
  }
};
</script>

<style lang='scss'>
.arrow-right {
  img {
    width: 34px;
    height: auto;
    &:hover {
      transform: rotate(-30deg);
    }
  }
}
</style>